'use strict';

module.exports = /*@ngInject*/ ["$timeout", function ($timeout) {

    return {
        createNotification: createNotification
    };

    function createNotification(title, body, timeout) {
        var notification = new Notification(title, {
            icon: 'img/new-logo.png',
            body: body,
        });

        notification.onshow = function () {
            if (timeout != -1) {
                $timeout(function () {
                    notification.close();
                }, timeout)
            }
        };
        notification.onclick = function () {
            window.focus();
        };
    }


}];